<template>
    <div class="edit-pwd-box">
        <el-form
            :model="passwordForm"
            :rules="passwordRules"
            ref="passwordForm"
            label-width="420px"
        >
            <el-form-item prop="oldPwd" size="small" label="原始密码">
                <el-input type="password"  style="width: 260px" v-model.trim="passwordForm.oldPwd" autocomplete="off"
                    placeholder="请输入您的原始密码"
                ></el-input>
            </el-form-item>
            <el-form-item prop="passWd" size="small" label="新设密码">
                <el-input type="password"  style="width: 260px" v-model.trim="passwordForm.passWd" autocomplete="off"
                    placeholder="请输入您的新设密码"
                ></el-input>
            </el-form-item>
            <el-form-item prop="checkPassWd" size="small" label="确认密码">
                <el-input type="password"  style="width: 260px" v-model.trim="passwordForm.checkPassWd" autocomplete="off"
                    placeholder="请再次输入您的新设密码"
                ></el-input>
            </el-form-item>
            <el-form-item label="">
                <button class="cg-btn red" type="button" @click="submitPassword">确认修改</button>
                <span class="forget-password" @click="openForgetPwdBox">忘记密码？</span>
            </el-form-item>
        </el-form>

        <el-dialog
            title="忘记密码"
            :visible.sync="forgetPwdDialogVisible"
            width="660px"
            :close-on-click-modal="false">
            <div class="forget-pwd-wrap">
                <el-form
                    :model="forgetPwdForm"
                    :rules="forgetPwdRules"
                    ref="forgetPwdForm"
                    label-width="100px"
                >
                    <el-form-item prop="phone" size="small" label="手机号">
                        <el-input type="text" v-model.trim="forgetPwdForm.phone" autocomplete="off"
                            placeholder="请输入您的手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="code" size="small" class="code-line" label="验证码">
                        <el-input type="text" v-model.trim="forgetPwdForm.code" autocomplete="off"
                            placeholder="请输入您的验证码"
                        ></el-input>
                        <button class="code-btn" type="button" @click="sentCodeHandle">{{sentCodeText}}</button>
                    </el-form-item>
                    <el-form-item prop="passWd" size="small" label="输入密码">
                        <el-input type="password" v-model.trim="forgetPwdForm.passWd" autocomplete="off"
                            placeholder="请输入您的密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPassWd" size="small" label="确认密码">
                        <el-input type="password" v-model.trim="forgetPwdForm.checkPassWd" autocomplete="off"
                            placeholder="请再次输入您的密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <button class="cg-btn" type="button" @click="cancelSetForgetPwd">取消</button>
                        <button class="cg-btn red mgl-16" type="button" @click="submitForgetPwd">确定</button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { RequestUpdatePassWd, RequestPhoneCode, RequestForgetPassWd  } from '../../../api/public'
import { validateMobile, validateCombinationPwd } from '../../../utils/validate'
import { mapGetters } from 'vuex'
export default {
    data() {
        var validateOldPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入原始密码'))
            } else {
                callback()
            }
        }
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新设密码'))
            } else if (!validateCombinationPwd(value)){
                callback(new Error('密码格式不正确，请输入6-16位组合密码'))
            } else {
                callback()
            }
        }
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入新设密码'))
            } else if (value != this.passwordForm.passWd){
                callback(new Error('两次密码输入不一致'))
            } else {
                callback()
            }
        }
        var validatePhone =  (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!validateMobile(value)){
                callback(new Error('手机号格式不正确'))
            } else {
                callback()
            }
        }

        var validatePass3 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value != this.forgetPwdForm.passWd){
                callback(new Error('两次密码输入不一致'))
            } else {
                callback()
            }
        }
        return {
            // 修改密码
            passwordForm: {
                oldPwd: '',
                passWd: '',
                checkPassWd: ''
            },
            passwordRules: {
                oldPwd: [
                    { validator: validateOldPass, trigger: 'change' }
                ],
                passWd: [
                    { validator: validatePass, trigger: 'change' }
                ],
                checkPassWd: [
                    { validator: validatePass2, trigger: 'change' }
                ]
            },

            // 忘记密码
            forgetPwdDialogVisible: false,
            forgetPwdForm: {
                phone: '',
                code: '',
                passWd: '',
                checkPassWd: ''
            },
            forgetPwdRules: {
                phone: [
                    { required: true, validator: validatePhone, trigger: 'change' }
                ],
                code: [
                    { required: true, message: "请输入验证码", trigger: 'change' }
                ],
                passWd: [
                    { required: true, validator: validatePass, trigger: 'change' }
                ],
                checkPassWd: [
                    { required: true, validator: validatePass3, trigger: 'change' }
                ]
            },
            // 验证码相关
            sentCodeBtn: true,
            sentCodeText: '发送验证码',
            sentCodeTimer: null,
        }
    },
    computed: {
        ...mapGetters(['userId', 'account'])
    },
    created() {

    },
    methods: {
        // 修改密码
        submitPassword() {
            this.$refs['passwordForm'].validate((valid) => {
                if (valid) {
                    RequestUpdatePassWd({
                        phone: this.account,
                        passWd: this.passwordForm.passWd,
                        oldPwd: this.passwordForm.oldPwd,
                        checkPassWd: this.passwordForm.checkPassWd,
                        userId: this.userId
                    }).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.$refs['passwordForm'].resetFields()
                            this.$message.success('密码设置成功')
                        } else {
                            this.$message.error(res.errorMsg || '密码设置失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },

        // 忘记密码
        openForgetPwdBox () {
            this.forgetPwdDialogVisible = true
        },
        cancelSetForgetPwd () {
            this.forgetPwdDialogVisible = false
        },
        submitForgetPwd () {
            this.$refs['forgetPwdForm'].validate((valid) => {
            if (valid) {
                RequestForgetPassWd({
                    phone: this.forgetPwdForm.phone,
                    code:  this.forgetPwdForm.code,
                    passWd:  this.forgetPwdForm.passWd,
                    checkPassWd:  this.forgetPwdForm.checkPassWd,
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message.success('密码设置成功')
                        this.forgetPwdDialogVisible = false
                    } else {
                        this.$message.error(res.errorMsg || '密码设置失败')
                    }
                    }).catch(err => {
                    console.log(err)
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        // 获取验证码
        sentCodeHandle() {
            if (this.sentCodeBtn) {
              this.$refs['forgetPwdForm'].validateField('phone', (err) => {
                console.log(err)
                if (!err) {
                  RequestPhoneCode(this.forgetPwdForm.phone).then(res => {
                      console.log(res)
                      if (res.errorCode == 200) {
                          this.$message.success('验证码发送成功')
                      } else {
                          this.$message.error('验证码发送失败')
                      }
                  }).catch(err => {
                      console.log(err)
                  })
                  this.sentCodeBtn = false
                  let t = 60
                  this.sentCodeText = t + 's'
                  clearInterval(this.sentCodeTimer)
                  this.sentCodeTimer = setInterval(() => {
                      if (t > 0) {
                          t --
                          this.sentCodeText = t + 's'
                      } else {
                          this.sentCodeText = '获取验证码'
                          this.sentCodeBtn = true
                          clearInterval(this.sentCodeTimer)
                      }
                  }, 1000)
                }
              })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.edit-pwd-box {
    background: #fff; padding:100px 0;
    .forget-password {
        margin-left: 16px;
        font-size:12px;
        color:rgba(42,46,63,1);
        line-height:18px;
        cursor: pointer;
    }  
}
.forget-pwd-wrap {
    width: 450px;
    margin: 0 auto;
    .code-line {
        .el-input {
            position: relative;
            width: 224px;
        }
        .code-btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 116px;
            height: 32px;
            background:rgba(255,255,255,1);
            border-radius: 4px;
            border:1px solid rgba(248,29,34,0.5);
            font-size:14px;
            color:rgba(248,29,34,1);
            outline: none;
        }
    }
}
</style>